import React, { useState } from "react";
import ReactTooltip from "react-tooltip";

const ORIGINE_FRANCE_TRAVAIL = "FRANCE_TRAVAIL";

/**
 * Indique si une inscription EP a été créée automatiquement suite à une
 * proposition de sanction France Travail (par opposition à une inscription
 * manuelle).
 */
export const estOrigineFranceTravail = (inscription) =>
  inscription?.registrationOrigin === ORIGINE_FRANCE_TRAVAIL;

// Compteur module : garantit des ids de tooltip uniques quand le badge
// apparaît plusieurs fois à l'écran (ex. carte + modale).
let nbInstances = 0;

/**
 * Badge signalant une inscription EP d'origine France Travail. Purement
 * présentationnel : l'affichage conditionnel est à la charge de l'appelant,
 * via estOrigineFranceTravail.
 *
 * - fontSize : taille du badge (11 par défaut, 12 dans la bannière de décision)
 */
const BadgeOrigineFranceTravail = ({ fontSize = 11 }) => {
  const [tooltipId] = useState(() => `badge-origine-ft-${++nbInstances}`);

  return (
    <span
      className="d-inline-flex align-items-center px-2 py-1 rounded"
      style={{
        background: "#dbeafe",
        color: "#1e40af",
        fontSize,
        fontWeight: 600,
        gap: 4,
      }}
      data-tip="Inscription automatique suite à une proposition de sanction France Travail"
      data-for={tooltipId}
    >
      <i className="fa fa-bolt" style={{ fontSize: fontSize - 1 }} aria-hidden="true" />
      France Travail
      <ReactTooltip id={tooltipId} place="top" effect="solid" delayShow={0} />
    </span>
  );
};

export default BadgeOrigineFranceTravail;
